import * as Sentry from '@sentry/react';
import { QueryClient } from '@tanstack/react-query';

// Create a QueryClient instance with default options
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Time before a query is considered stale (5 minutes)
      staleTime: 5 * 60 * 1000,
      // Time before inactive queries are garbage collected (10 minutes)
      gcTime: 10 * 60 * 1000,
      // Retry failed requests 1 time before throwing an error
      retry: 1,
      // Refetch on window focus
      refetchOnWindowFocus: false,
      // Refetch on reconnect
      refetchOnReconnect: true,
      // Refetch on mount to ensure fresh data after page refresh
      refetchOnMount: true,
    },
    mutations: {
      // Retry failed mutations 0 times (no retry for mutations by default)
      retry: 0,
      // Global error handler for mutations
      onError: (error) => {
        Sentry.captureException(error, {
          extra: { context: 'mutation_global' },
        });
      },
    },
  },
});
